import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCircle,
  faExternalLink,
  faRightFromBracket,
  faUser,
  faUserGear,
  faUserShield,
  faCaretDown,
  faBars,
  faFilter,
  faLongArrowAltDown,
  faLongArrowAltUp,
  faTimes,
  faEye,
  faThumbTack,
  faClipboardList,
  faTrashAlt,
  faCircleCheck,
  faCircleExclamation,
  faPencil,
  faFloppyDisk,
  faArrowLeft,
  faChevronLeft,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faCircle,
  faCircleExclamation,
  faExternalLink,
  faRightFromBracket,
  faUser,
  faUserGear,
  faUserShield,
  faCaretDown,
  faBars,
  faFilter,
  faLongArrowAltDown,
  faLongArrowAltUp,
  faTimes,
  faEye,
  faThumbTack,
  faClipboardList,
  faTrashAlt,
  faCircleCheck,
  faCircleExclamation,
  faPencil,
  faFloppyDisk,
  faArrowLeft,
  faChevronLeft
);
